/** Entries for the project settings search box. */
export const releasesSettingsIndex = [
  {
    path: "/releases",
    title: "Releases",
    keywords: ["release", "version", "datasheet", "citation", "snapshot", "dataset", "changelog"],
  },
];
